import React from 'react';
import { Search, QrCode } from 'lucide-react';
import KioskBookingCard from './KioskBookingCard';

export default function BookingCheckInList({
  bookings,
  experiences,
  search,
  onSearch,
  selectedBookingId,
  onSelect,
  onScan,
}) {
  return (
    <section className="flex flex-col h-full min-h-0 border-r border-white/10 bg-[#0b0b0e]">
      <div className="px-5 pt-5 pb-4 border-b border-white/10">
        <div className="flex items-baseline justify-between">
          <h2 className="text-white font-black text-base uppercase tracking-tight">Upcoming Bookings &amp; Check-In</h2>
          <span className="text-white/40 text-[11px] font-bold tracking-widest">{bookings.length} TODAY</span>
        </div>

        <div className="flex gap-2 mt-4">
          <div className="relative flex-1">
            <Search className="w-4 h-4 text-white/30 absolute left-3.5 top-1/2 -translate-y-1/2" />
            <input
              value={search}
              onChange={(e) => onSearch(e.target.value)}
              placeholder="Search name, email or reference"
              className="w-full bg-black/40 border border-white/10 focus:border-primary/60 text-white text-sm pl-10 pr-3 py-3.5 outline-none placeholder:text-white/25"
            />
          </div>
          <button
            onClick={onScan}
            className="flex items-center gap-2 shrink-0 bg-primary hover:bg-primary/90 text-white font-bold text-xs tracking-widest px-4 py-3.5 transition-colors"
          >
            <QrCode className="w-4 h-4" /> SCAN QR CODE
          </button>
        </div>
      </div>

      <div className="flex-1 min-h-0 overflow-y-auto p-5 space-y-3">
        {bookings.length === 0 ? (
          <p className="text-white/30 text-sm text-center py-16 border border-white/5">
            No bookings match this filter for today.
          </p>
        ) : (
          bookings.map((b) => (
            <KioskBookingCard
              key={b.id}
              booking={b}
              experiences={experiences}
              selected={selectedBookingId === b.id}
              onSelect={onSelect}
            />
          ))
        )}
      </div>
    </section>
  );
}